import React, { useState, useEffect } from "react";
import "./OurSuccess2.css";
import icon1 from '../Imges/360_F_294621430_9dwIpCeY1LqefWCcU23pP9i11BgzOS0N.jpg';
import icon2 from '../Imges/1687959479_sneg-top-p-avatarka-delovogo-muzhchini-krasivo-41.jpg';
import icon3 from '../Imges/Feature_Image_CuteProfessional.jpg';
import icon4 from '../Imges/Making-Time-For-Cosmetic-Dental-Work-Before-A-Big-Event.jpeg.jpg';
import icon6 from '../Imges/ThinkstockPhotos-200488040-001-1.jpg';
import icon5 from '../Imges/XXL_height.jpeg.jpg';
import icon7 from '../Imges/emp3.png';
import icon8 from '../Imges/emp-2.png';
import icon9 from '../Imges/emp-3.png';

const Testimonials = () => {
  const testimonialsData = [
    {
      name: "John Doe",
      position: "CEO",
      testimonial:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.",
      image: icon1,
    },
    {
      name: "Jane Smith",
      position: "CTO",
      testimonial:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.",
      image: icon2,
    },
    {
      name: "Alice Johnson",
      position: "CMO",
      testimonial:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.",
      image: icon3,
    },
    {
      name: "Mark Lee",
      position: "Manager",
      testimonial:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.",
      image: icon4,
    },
    {
      name: "Emily Rose",
      position: "Designer",
      testimonial:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.",
      image: icon5,
    },
    {
      name: "David Kim",
      position: "Engineer",
      testimonial:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.",
      image: icon6,
    },
    {
      name: "Michael Brown",
      position: "CTO",
      testimonial:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.",
      image: icon7,
    },
    {
      name: "Sophia Green",
      position: "CMO",
      testimonial:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.",
      image: icon8,
    },
    {
      name: "James Wilson",
      position: "Manager",
      testimonial:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.",
      image: icon9,
    },
  ];

  const cardsPerSlide = window.innerWidth <= 768 ? 1 : 3; // Display 1 item per slide for mobile, 3 for desktop
  const totalSlides = Math.ceil(testimonialsData.length / cardsPerSlide);
  const [currentSlide, setCurrentSlide] = useState(0);

  // Auto-slide every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % totalSlides);
    }, 3000);
    return () => clearInterval(interval);
  }, [totalSlides]);

  const handleDotClick = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div>
      <section className="testimonials multi">
        <div
          className="testimonial-slider"
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
        >
          {Array.from({ length: totalSlides }).map((_, slideIndex) => (
            <div className="testimonial-slide" key={slideIndex}>
              {testimonialsData
                .slice(
                  slideIndex * cardsPerSlide,
                  slideIndex * cardsPerSlide + cardsPerSlide
                )
                .map((testimonial, index) => (
                  <div className="testimonial-card" key={index}>
                    <p>{testimonial.testimonial}</p>
                    <div className="user-info">
                      <img src={testimonial.image} alt="User" />
                      <div className="user-text">
                        <h4>{testimonial.name}</h4>
                        <span>{testimonial.position}</span>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          ))}
        </div>
      </section>

      <div className="dots">
        {Array.from({ length: totalSlides }).map((_, index) => (
          <span
            key={index}
            className={`dot ${currentSlide === index ? "active" : ""}`}
            onClick={() => handleDotClick(index)}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default Testimonials;
